<template lang="pug">
#modal-analise-elegibilidade
    el-dialog.modal-analise-elegibilidade(
        :visible.sync='show',
        width='80%',
        :before-close='handleCloseModal',
        :close-on-click-modal='false',
        :fullscreen='false',
        append-to-body,
        destroy-on-close
    )
        span(slot='title')
            h3.modal-analise-elegibilidade--header.mr-1 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analiseDeElegibilidade') }}
                .analise-elegibilidade--header__status
                    .analise-elegibilidade--header__status-diagnostico(
                        :class='statusElegibilidade[dados.elegibilidade] ? statusElegibilidade[dados.elegibilidade].classeCor : ""'
                    )
                        i.mdi.mdi-check-circle(
                            v-if='dados.elegibilidade === "ELEGIVEL"'
                        )
                        i.mdi.mdi-information.font-size-mdi(
                            v-else-if='dados.elegibilidade === "ALERTA"'
                        )
                        i.flow.flow-warning-sign(
                            v-else-if='dados.elegibilidade === "INELEGIVEL"'
                        )

                        span
                        | {{ statusElegibilidade[dados.elegibilidade] ? statusElegibilidade[dados.elegibilidade].status : '' }}

        .modal-analise-elegibilidade--body
            .direita.lista-scroll
                .modal-analise-elegibilidade--sub-title
                    i.mdi.mdi-check-circle(
                        v-if='classeDiagnosticoCar === "BAIXO"',
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    i.mdi.mdi-information.font-size-mdi(
                        v-else-if='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    i.flow.flow-warning-sign.mr-1(
                        v-else,
                        :class='statusDiagnostico[classeDiagnosticoCar] ? statusDiagnostico[classeDiagnosticoCar].corClasse : ""'
                    )
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.diagnosticoSocioambiental') }}
                .modal-analise-bloco
                    .modal-analise-bloco--title
                        .modal-analise-bloco--title--car
                            span RENSPA:
                        .modal-analise-bloco--title--descricao
                            span
                            |
                            | {{ this.mascaraRenspa(dados.territorioOutput?.renspa) }}
                    hr
                    .modal-analise-bloco-lista-scroll
                        el-collapse(
                            v-model='collapseAtivo',
                            @change='exibirRestricoesNoMapa',
                            accordion
                        )
                            el-collapse-item(
                                v-for='(diagnostico, index) in dados.dadosDiagnostico.diagnosticoGeometria',
                                v-if='diagnostico.nivelAlerta !== "BAIXO"',
                                :key='index',
                                :name='index'
                            )
                                template(slot='title')
                                    i.mr-2.flow.flow-warning-sign.mr8.custon-icon-collapse--menor(
                                        v-if='diagnostico.nivelAlerta === "ALTO"',
                                        :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                    )
                                    i.mdi.mdi-information.font-size-mdi.mr8.custon-icon-collapse--menor(
                                        v-else='classeDiagnosticoCar === "MEDIO" || classeDiagnosticoCar === "MEDIO_ALTO"',
                                        :class='statusDiagnostico[diagnostico.nivelAlerta].corClasse'
                                    )
                                    span
                                    | {{ $t(`mensagens.camadas.${diagnostico.camada.codigo}`) }}

                                    div(v-if='diagnostico.resultados.length')
                                        el-tag.custon-tag(
                                            size='mini',
                                            type='danger'
                                        ) {{ diagnostico.resultados.length }}

                                div(
                                    v-if='diagnostico && diagnostico.resultados.length'
                                )
                                    component(
                                        ref='componente',
                                        v-bind:is='prepararComponente(diagnostico)',
                                        v-bind='prepararDadosParaComponente(diagnostico)',
                                        @aplicar-zoom-restricao='aplicarZoomRestricao'
                                    )

                                .container-sem-restricoes(
                                    v-if='diagnostico.resultados.length === 0'
                                )
                                    p {{ $t('mensagens.relatorioRastreabilidade.cadastro.naoHaRestricoes') }}

                                Fonte(
                                    :fonte='diagnostico?.camada?.fonte ? diagnostico.camada.fonte : {}',
                                    collapse-class='my-3'
                                )

                        p(
                            v-if='classeDiagnosticoCar === "BAIXO"',
                            :class='statusDiagnostico[classeDiagnosticoCar].corClasse'
                        ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.nenhumaConformidade') }}

                .modal-analise-bloco-bloco--title
                    i.mdi.mdi-check-circle.status-sucess
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.certificacao') }}
                .modal-analise-bloco
                    .modal-analise-bloco--title
                        .modal-analise-bloco--title--car
                            span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.certificacao') }}
                        .modal-analise-bloco--title--descricao
                            span(
                                v-if='dados.certificacao.possuiCertificacaoParaEsseContrato == true'
                                :class='statusDiagnostico["BAIXO"].corClasse'
                            ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel') }}
                            span(
                                v-else,
                                :class='statusDiagnostico["MEDIO_ALTO"].corClasse'
                            ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel') }}
                    hr
                    .modal-analise-bloco--title
                        .modal-analise-bloco--title--car
                            span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.evidencias') }}
                        .modal-analise-bloco--title--descricao
                            i.mdi.mdi-check-circle.status-sucess(
                                v-if='dados.certificacao.possuiEvidenciasDessaCertificacao == true',
                                :class='statusDiagnostico["BAIXO"].corClasse'
                            )
                            i.mdi.mdi-close-circle.status-danger(
                                v-else,
                                :class='statusDiagnostico["MEDIO_ALTO"].corClasse'
                            )

                .modal-analise-bloco-bloco--title(v-if='exibeBlocoDistancia()')
                    i.mdi.mdi-check-circle.status-sucess(
                        v-if='raioPermitido()'
                    )
                    i.flow.flow-warning-sign.mr-1.status-danger(v-else)
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.distancia') }}
                .modal-analise-bloco(v-if='exibeBlocoDistancia()')
                    .bloco-distancia
                        p.bloco-distancia--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaImovelAoMunicipio') }} {{ dados.dadosCalculoRaio.distanciaRaioLocalidade }} km
                        el-alert(
                            :title='getTitleDistanciaImovel()',
                            :type='raioPermitido() ? "success" : "error"',
                            show-icon,
                            :closable='false'
                        )

                .modal-analise-bloco-bloco--title
                    i.mdi.mdi-check-circle.status-sucess
                    h4.direita-sub-title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdutivaArea') }}
                .modal-analise-bloco
                    .bloco-capacidade-produtiva--conteudo
                        span.bloco-capacidade-produtiva--conteudo--interno
                            .bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.area') }}
                            | {{ formatArea(dados.saldoTerritorial.areaHa) ?? '---' }} ha

                        .bloco-capacidade-produtiva--conteudo-baixo
                            .bloco-capacidade-produtiva--conteudo-baixo--interno
                                el-tooltip(
                                    placement='top',
                                    :content='`${$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.fonte")}: ${$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.ministerioAr")}`'
                                )
                                    span
                                        i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                        span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.produtividade') }}
                                | {{ formatArea(dados.saldoTerritorial.rendimento) ?? '---' }} t/ha

                    hr

                    .bloco-capacidade-produtiva--conteudo-baixo
                        span.bloco-capacidade-produtiva--conteudo--interno
                            el-tooltip(
                                placement='top',
                                :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdXAreaConsolidada")'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.capacidadeProdutiva') }}
                            | {{ formatArea(dados.saldoTerritorial.capacidadeProdutiva) }} t

                            span.bloco-capacidade-produtiva--conteudo--interno
                            el-tooltip(
                                placement='top',
                                :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.valorUtilizadoCapacidade")'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.saldoComprometido') }}
                            span.status-danger {{ formatArea(dados.saldoTerritorial.saldoConsumidoCapacidadeProdutiva) }} t

                        span.bloco-capacidade-produtiva--conteudo--interno
                            el-tooltip(
                                placement='top',
                                :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.valordisponivelCapacidade")'
                            )
                                span
                                    i.mdi.mdi-information-outline.font-size-mdi.mr-2
                                    span.bloco-capacidade-produtiva--conteudo--title {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.saldoDisponivel') }}
                            span.status-sucess {{ formatArea(dados.saldoTerritorial.saldoCapacidadeProdutiva) }} t

            .esquerda
                .mapa-elegibilidade
                    Mapa(
                        v-if='mostrarMapa',
                        :key='mapKey',
                        ref='mapaAr',
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :height='"93%"',
                        :idMapa='"mapaAnaliseEleigibilidadeResumo"'
                    )

        span(slot='footer')
            el-button(type='primary', @click='handleCloseModal') {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.voltar') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';
import ApriaReservaDeLaBiosfera from '@/components/diagnosticoSocioambiental/ApriaReservaDeLaBiosfera.vue';
import ReservaProvinciale from '@/components/diagnosticoSocioambiental/ReservaProvinciale.vue';
import DesmatamentoInfonaParaguai from '@/components/diagnosticoSocioambiental/DesmatamentoInfonaParaguai.vue';
import OtbnArgentina from '../diagnosticoSocioambiental/OtbnArgentina.vue';
import AppArgentinaPontos from '../diagnosticoSocioambiental/AppArgentinaPontos.vue';
import AppArgentinaPoligonos from '../diagnosticoSocioambiental/AppArgentinaPoligonos.vue';
import ApnSifap from '../diagnosticoSocioambiental/ApnSifap.vue';
import ApriaPatrimonioDaHumanidadPuntos from '../diagnosticoSocioambiental/ApriaPatrimonioDaHumanidadPuntos.vue';
import ApriaSitiosRamsar from '../diagnosticoSocioambiental/ApriaSitiosRamsar.vue';
import DesmatamentoArgentina from '../diagnosticoSocioambiental/DesmatamentoArgentina.vue';
import DesmatamentoArgentina2025 from '../diagnosticoSocioambiental/DesmatamentoArgentina2025.vue';

import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';

const restricaoPattern =
    'https://lyra-bunge-publico.s3.amazonaws.com/restricao_pattern.gif';

export default {
    name: 'ModalAnaliseElegibilidadeResumoAr',
    components: {
        Mapa,
        DesmatamentoInfonaParaguai,
        Fonte,
        ApriaReservaDeLaBiosfera,
        OtbnArgentina,
        ReservaProvinciale,
        AppArgentinaPontos,
        AppArgentinaPoligonos,
        ApnSifap,
        ApriaPatrimonioDaHumanidadPuntos,
        ApriaSitiosRamsar,
        DesmatamentoArgentina,
        DesmatamentoArgentina2025
    },
    emits: ['handleCloseModalAnaliseElegibidade'],
    props: {
        show: {
            type: Boolean
        },
        dados: {
            type: Object
        }
    },
    data() {
        return {
            mostrarMapa: false,
            mapKey: 0,
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: false,
                diagnostico: false
            },
            collapseAtivo: '',
            collapseAtivoPessoa: '',
            refMapa: null,
            carregandoProdutividade: false,
            dadosProdutividade: {
                estado: {
                    nome: ''
                },
                area: null,
                areaUnidadeMedida: '',
                produtividade: null,
                produtividadeUnidadeMedida: '',
                capacidadeProdutiva: null,
                capacidadeProdutivaUnidadeMedida: '',
                calculoSaca: {
                    mediaRegional: null,
                    produtividade: null
                },
                fatorProdutividade: null,
                fonteDados: {
                    id: null,
                    nome: '',
                    sigla: ''
                }
            },
            classeDiagnosticoCar: 'INDEFINIDO',
            classeDiagnostcoRepresentante: '',
            restricaoRepresentante: false,
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: 'Alerta'
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: 'Alerta'
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: 'Conforme'
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: 'Inconforme'
                },
                INDEFINIDO: {
                    corClasse: '',
                    status: ''
                }
            },
            statusElegibilidade: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.comAlerta'
                    )
                }
            }
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    watch: {
        show: function () {
            if (!this.show) return;

            this.mostrarMapa = false; // Força destruição
            this.$nextTick(() => {
                this.mapKey = Date.now(); // Nova key para forçar recriação
                this.mostrarMapa = true;
                this.$nextTick(() => {
                    const mapaAr = this.$refs.mapaAr;

                    if (mapaAr) {
                        this.mostrarTerritorioNoMapa();
                        this.definirStatusTerritorio();
                        this.definirStatusRepresentante();
                    } else {
                        // eslint-disable-next-line no-console
                        console.error(
                            'O componente Mapa não foi carregado corretamente.'
                        );
                    }
                });
            });
        }
    },
    methods: {
        handleCloseModal() {
            this.mostrarMapa = false; // Garante destruição ao fechar
            this.$emit('handleCloseModalAnaliseElegibidade');
        },
        mostrarTerritorioNoMapa() {
            this.refMapa = this.$refs['mapaAr'];

            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território analisado',
                geoJson: this.dados.territorioOutput.geometria
            };

            this.layersMaps.push(layerTerritorio);
            let geoJson = this.dados.territorioOutput.geometria;
            this.refMapa.aplicarZoomGeoJson(geoJson);
        },
        aplicarZoomRestricao(
            restricao,
            geometriaQueNaoEstavaDentroDasRestricoes,
            index
        ) {
            let geoJson =
                restricao.geometry ||
                restricao.geometria ||
                restricao.properties?.geometry ||
                restricao.properties?.geometria ||
                restricao.propriedade?.geometry ||
                restricao.propriedade?.geometria ||
                geometriaQueNaoEstavaDentroDasRestricoes;

            if (
                !geoJson &&
                restricao.properties?.latitude &&
                restricao.properties?.longitude
            ) {
                geoJson = {
                    type: 'Point',
                    coordinates: [
                        restricao.properties.longitude,
                        restricao.properties.latitude
                    ]
                };
            }
            this.refMapa = this.$refs['mapaAr'];

            this.refMapa.aplicarZoomGeoJson(geoJson);
        },
        prepararComponente(diagnostico) {
            const partes = diagnostico.camada.codigo.split('_');
            const resultado = partes.map(parte => {
                return (
                    parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase()
                );
            });
            return resultado.join('');
        },
        prepararDadosParaComponente(diagnostico) {
            const arrayGeometria = [];
            diagnostico.resultados.forEach(geom => {
                arrayGeometria.push(geom.geometry);
            });
            return {
                restricoes: diagnostico.resultados,
                geometria: arrayGeometria,
                habilitarZoomRestricao: true
            };
        },
        removerRestricoesNoMapa() {
            this.layersMaps = this.layersMaps.filter(
                layer => layer.name === `Território analisado`
            );
        },
        definirStatusRepresentante() {
            if (
                this.dados?.dadosDiagnostico?.diagnosticoRepresentante?.length
            ) {
                this.restricaoRepresentante = false;
                this.dados.dadosDiagnostico.diagnosticoRepresentante.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta !== 'BAIXO') {
                            this.restricaoRepresentante = true;
                        }
                    }
                );
            }
        },
        exibirSatausSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return 'Ativo';
                case 'CA':
                    return 'Cancelado';
                case 'PE':
                    return 'Pendente';
                default:
                    return situacao;
            }
        },
        definirStatusTerritorio() {
            this.classeDiagnosticoCar = 'INDEFINIDO';
            let laranja = false;
            let vermelho = false;
            let amarelo = false;
            if (this.dados.dadosDiagnostico?.diagnosticoGeometria.length) {
                this.dados.dadosDiagnostico.diagnosticoGeometria.forEach(
                    diagnostico => {
                        if (diagnostico.nivelAlerta === 'ALTO') {
                            vermelho = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO') {
                            amarelo = true;
                        }
                        if (diagnostico.nivelAlerta === 'MEDIO_ALTO') {
                            laranja = true;
                        }
                    }
                );
            }
            if (vermelho) {
                this.classeDiagnosticoCar = 'ALTO';
            } else if (laranja) {
                this.classeDiagnosticoCar = 'MEDIO_ALTO';
            } else if (amarelo) {
                this.classeDiagnosticoCar = 'MEDIO';
            } else {
                this.classeDiagnosticoCar = 'BAIXO';
            }
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },
        formatArea(number) {
            const numericValue = parseFloat(number);
            return Number.isInteger(numericValue)
                ? numericValue.toString()
                : numericValue.toFixed(3);
        },
        exibirRestricoesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivo === 'string' &&
                this.collapseAtivo === ''
            ) {
                return;
            }

            const areas = this.dados.dadosDiagnostico?.diagnosticoGeometria[
                this.collapseAtivo
            ].resultados.filter(
                resultado =>
                    resultado.geometria ||
                    resultado.geometry ||
                    (resultado.properties.latitude &&
                        resultado.properties.longitude)
            );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivo,
                            group: `grupo-restricoes-${this.collapseAtivo}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-${this.collapseAtivo}`,
                                indexDiagnostico: this.collapseAtivo,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnostico-${this.collapseAtivo}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-${this.collapseAtivo}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        exibirRestricoesRepresentantesNoMapa() {
            this.removerRestricoesNoMapa();
            if (
                typeof this.collapseAtivoPessoa === 'string' &&
                this.collapseAtivoPessoa === ''
            ) {
                return;
            }

            const areas = this.dados.dadosDiagnostico.diagnosticoRepresentante[
                this.collapseAtivoPessoa
            ].resultados.filter(
                resultado =>
                    resultado.geometria ||
                    resultado.geometry ||
                    (resultado.properties.latitude &&
                        resultado.properties.longitude)
            );

            const opacidade = 0.5;

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    const name = `AreaDiagnosticoRepresentante-${this.collapseAtivo}-${index}`;
                    if (!this.layersMaps.find(layer => layer.name === name)) {
                        this.layersMaps.push({
                            name,
                            indexDiagnostico: this.collapseAtivoPessoa,
                            group: `grupo-restricoes-representante-${this.collapseAtivoPessoa}`,
                            style: {
                                color: '#c20a0a',
                                weight: 1,
                                fill: 'url(' + restricaoPattern + ')',
                                opacity: opacidade,
                                fillOpacity: opacidade
                            },
                            geoJson: geometria
                        });
                    }

                    let icon = null;

                    if (geometria.type !== 'Point') {
                        icon = L.icon({
                            iconUrl:
                                'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });
                        const nameCentroid = `CentroidDiagnosticoRepresentante-${this.collapseAtivoPessoa}-${index}`;
                        if (
                            !this.layersMaps.find(
                                layer => layer.name === nameCentroid
                            )
                        ) {
                            this.layersMaps.push({
                                name: nameCentroid,
                                group: `grupo-centroid-representante-${this.collapseAtivoPessoa}`,
                                indexDiagnostico: this.collapseAtivoPessoa,
                                icon,
                                geoJson: centroidFromGeoJSON.get(geometria)
                            });
                        }
                    }
                } else {
                    const { properties } = area;
                    if (
                        properties &&
                        properties.latitude &&
                        properties.longitude
                    ) {
                        const name = `AreaDiagnosticoRepresentante-${this.collapseAtivoPessoa}-${index}`;
                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: this.collapseAtivo,
                                group: `grupo-restricoes-representante-${this.collapseAtivoPessoa}`,
                                style: {
                                    color: '#c20a0a',
                                    weight: 10,
                                    fill: 'url(' + restricaoPattern + ')',
                                    opacity: 0.5,
                                    fillOpacity: opacidade
                                },
                                geoJson: {
                                    type: 'Point',
                                    coordinates: [
                                        properties.longitude,
                                        properties.latitude
                                    ]
                                }
                            });
                        }
                    }
                }
            });
        },
        raioPermitido() {
            return (
                this.dados.dadosCalculoRaio.distanciaRaioLocalidade <=
                this.dados.dadosCalculoRaio.distanciaPermitida
            );
        },
        possuiRestricaoEstado() {
            if (this.dados.dadosRestricaoEstado?.possuiRestricaoEstado) {
                return true;
            }
            return false;
        },
        possuiRestricaoMunicipio() {
            if (this.dados.dadosRestricaoMunicipio?.possuiRestricaoMunicipio) {
                return true;
            }
            return false;
        },
        satisfazRestricaoEstado() {
            if (
                !this.dados.dadosRestricaoEstado?.possuiRestricaoEstado ||
                this.dados.dadosRestricaoEstado?.siglaEstadoCar ===
                    this.dados.dadosRestricaoEstado?.siglaEstadoPermitido
            ) {
                return true;
            }
            return false;
        },
        satisfazRestricaoMunicipio() {
            if (
                !this.dados.dadosRestricaoMunicipio?.possuiRestricaoMunicipio ||
                this.dados.dadosRestricaoMunicipio?.municipioCar ===
                    this.dados.dadosRestricaoMunicipio?.municipioPermitido
            ) {
                return true;
            }
            return false;
        },
        exibeBlocoDistancia() {
            if (
                this.satisfazRestricaoEstado() &&
                !this.dados.dadosRestricaoEstado?.aplicarTodoEstado
            ) {
                return true;
            }
            return false;
        },
        getTitleRestricaoImovel() {
            if (this.possuiRestricaoEstado()) {
                if (this.satisfazRestricaoEstado()) {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioDentroDoEstadoPermitido'
                    );
                } else {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioForaDoEstadoPermitido'
                    );
                }
            } else {
                return this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.ContratoNaoPossuiRestricaoDeEstado'
                );
            }
        },
        getTitleRestricaoMunicipio() {
            if (this.possuiRestricaoMunicipio()) {
                if (this.satisfazRestricaoMunicipio()) {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioDentroDoMunicipioPermitido'
                    );
                } else {
                    return this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioForaDoMunicipioPermitido'
                    );
                }
            } else {
                return this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.ContratoNaoPossuiRestricaoDeMunicipio'
                );
            }
        },
        getTitleExcecaoEstado() {
            return this.$t(
                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.TerritorioForaDoEstadoPermitido'
            );
        },
        getTitleDistanciaImovel() {
            const userAr = this.usuarioLogado.ambienteLogado === 'AR';

            if (this.raioPermitido()) {
                const mensagemBrasil = this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaDentroDoLimite'
                );
                const mensagemAr = this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaDentroDoLimitePY'
                );

                if (userAr) {
                    return mensagemAr;
                }

                return mensagemBrasil;
            }

            const mensagemExcedBr =
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaExcedidaDoLimite'
                ) +
                ` ${this.dados.dadosCalculoRaio.distanciaPermitida}` +
                'km.';
            const mensagemExcedAr =
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.distanciaExcedidaDoLimitePY'
                ) +
                ` ${this.dados.dadosCalculoRaio.distanciaPermitida}` +
                'km.';

            if (userAr) {
                return mensagemExcedAr;
            }

            return mensagemExcedBr;
        },
        formataFatorProdutividade() {
            if (this.dadosProdutividade.fatorProdutividade !== null) {
                const fatorProdutividade =
                    (100 + this.dadosProdutividade.fatorProdutividade) / 100;
                return formatters.formatNumber(fatorProdutividade, 2);
            }

            return '';
        },
        mascaraRenspa(renspa) {
            if (renspa === null || typeof renspa === 'undefined') {
                return ''; // Ou qualquer outro valor padrão que faça sentido (ex: 'N/A')
            }
            let formattedValue = String(renspa);
            const apenasNumeros = formattedValue.replace(/\D/g, '');

            const formato = apenasNumeros.replace(
                /^(\d{2})(\d{3})(\d{1})(\d{5})(\d{2})$/,
                '$1.$2.$3.$4/$5'
            );

            return formato;
        }
    }
};
</script>
<style lang="scss">
.modal-analise-elegibilidade {
    .status-amarelo {
        color: #bfae19;
        font-weight: 600;
    }

    .status-laranja {
        color: var(--warning);
        font-weight: 600;
    }

    .status-danger {
        color: var(--danger);
        font-weight: 600;
    }

    .status-sucess {
        color: var(--green);
        font-weight: 600;
    }

    .el-dialog__body {
        padding: 14px 15px;
        height: 515px;
    }

    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: #f6f6f6;
        color: #3b3b3b;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    .el-dialog__headerbtn {
        top: 10px;
    }

    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }

    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;

        .analise-elegibilidade--header__status {
            margin-left: 4px;
            display: flex;
            gap: 40px;

            .analise-elegibilidade--header__status-diagnostico {
                span {
                    margin-left: 4px;
                }
            }
        }
    }

    .direita-sub-title {
        font-weight: bold;
        color: #3b3b3b;
        font-size: 15px;
        margin-bottom: 8px;
        margin-top: 8px;
    }

    .modal-analise-elegibilidade--sub-title,
    .bloco-capacidade-produtiva--sub-title {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .modal-analise-elegibilidade--body {
        height: 495px;
        display: flex;
        justify-content: space-between;
        gap: 1%;

        .direita.lista-scroll {
            width: 52%;
            max-height: 495px;
            overflow: auto;
        }

        .esquerda {
            width: 47%;

            .mapa-elegibilidade {
                height: 100%;
                min-height: 568px;
                border-radius: 4px;
                overflow: hidden;
                margin: 0px 0 9px 0;
            }

            .bloco-distancia {
                min-height: 116px;
            }
        }

        .modal-analise-bloco-lista-scroll {
            overflow-y: auto;
            max-height: 230px;
            padding: 5px 0px;
        }

        .modal-analise-bloco-bloco--title {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .modal-analise-bloco {
            background: #f7f6f6;
            border-radius: 5px;
            padding: 12px 11px;

            &.modal-analise-bloco__baixo {
                margin-top: 18px;
            }

            .modal-analise-bloco-cpf-cnpj {
                .titulo {
                    color: #183b57;
                    font-weight: bold;
                    margin-right: 5px;
                }
            }

            .modal-analise-bloco--title {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #3b3b3b;
                margin-bottom: 13px;
                gap: 4px;
            }

            .container-sem-restricoes {
                p {
                    margin-left: 20px;
                }
            }

            .modal-analise-bloco--conteudo,
            .bloco-capacidade-produtiva--conteudo {
                display: flex;
                gap: 20px;
                justify-content: flex-start;
                flex-wrap: wrap;
            }

            .bloco-capacidade-produtiva--conteudo--interno {
                margin-bottom: 5px;
                display: flex;
                flex-direction: column;
            }

            .modal-analise-bloco--conteudo--interno--title,
            .bloco-capacidade-produtiva--conteudo--title,
            .bloco-distancia--conteudo--title,
            .modal-analise-bloco--title--car {
                color: #183b57;
                font-weight: bold;
            }

            .bloco-capacidade-produtiva--conteudo-baixo {
                display: flex;
                justify-content: flex-start;
                gap: 20px;
                flex-wrap: wrap;

                .bloco-capacidade-produtiva--conteudo-baixo--interno {
                    display: flex;
                    flex-direction: column;
                }
            }
        }

        .el-collapse-item__header {
            background-color: #f7f6f6;
            color: #3b3b3b;
        }

        .el-collapse-item__content {
            background: #f7f6f6;
        }

        .custon-icon-collapse--grande {
            font-size: 18px;
        }

        .custon-icon-collapse--menor {
            font-size: 13px;
        }
    }

    .el-dialog.is-fullscreen {
        .modal-analise-bloco-lista-scroll {
            max-height: 550px !important;
        }
    }

    .modal-anotacao-footer {
        display: flex;
        justify-content: space-between;
    }

    .el-alert__title {
        color: #3b3b3b;
        font-weight: bold;
    }

    i.custon-icon-collapse--menor {
        margin-right: 4px;
    }

    .lista-scroll::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    i {
        font-weight: 600;
    }
}
</style>
